import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';

export const MarketplaceTeamMembersMenuItem = () => (
    <LeftMenuItem
        icon="pe-7s-plugin"
        label="My Team Members"
        to="/opportunities?tab=my-team-members"
        trackingAction="My Team Members"
        gtmCategory="My Team Members"
    />
);
